<template>
  <div class="min-w-0">
    <div class="text-subtitle-1 mb-4">
      Пол и возраст пациентов
    </div>
    <DiagramGender class="mb-4" />
    <div
      class="d-flex flex-column gr-2"
      data-qa="diagram_line_list"
    >
      <DiagramLine
        v-for="(agePractice, i) in context.doctor_practice.practice_by_ages"
        :key="i"
        :label="agePractice.age"
        :percent="agePractice.frequency"
        :volume="maxAgePercent"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useContextStore } from 'src/store'
import type { ContextStore } from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/types'

import DiagramGender from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/DiagramGender.vue'
import DiagramLine from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/DiagramLine.vue'

const { context }: ContextStore = useContextStore()
const maxAgePercent = Math.max(...context.doctor_practice.practice_by_ages.map(o => o.frequency))
</script>
